import { WIS_EVENTS, WIS_RESPONSE_RECEIVED } from './constants';

export const responseWiService = (message, messageType, messageApp) => {
    return {
        type: WIS_RESPONSE_RECEIVED,
        message,
        messageType,
        messageApp
    };
};

export const disconnect = () => {
    return {
        type: WIS_EVENTS.CONNECT,
        payload: {
            isConnected: false
        }
    };
};
